/* eslint-disable @typescript-eslint/camelcase */

import * as Rox from "rox-browser";
import { BcsFlag } from "../unleash";

const bcsFlagsFeaturePartnerManagement = {
  permission_area_delivery_by_3lc_enable: new BcsFlag.JSONFlag([])
};

const roxFlagsFeaturePartnerManagement = {
  show_hide_bank_section: new Rox.Flag(false)
};

export const FlagsPermissionPartnerManagement = {
  ...roxFlagsFeaturePartnerManagement,
  ...bcsFlagsFeaturePartnerManagement
};

export function initFlagsPermissionPartnerManagement() {
  // register flags with namespaces for better grouping
  Rox.register("featurePartnerManagement", roxFlagsFeaturePartnerManagement);
  BcsFlag.register(
    "featurePartnerManagement",
    bcsFlagsFeaturePartnerManagement
  );
}
